<template>
  <div>
    <div v-if="showTitle" class="d-flex justify-space-between">
      <p class="font-weight-black"><span v-if="allowEdit">EDITAR</span> OBJECIÓN</p>
    </div>
    <v-form ref="formObjection" lazy-validation>
      <v-row class="fill-height px-3 pt-2">
        <v-col cols="12">
          <v-select
            v-model="objection"
            :value="getTicket.objection"
            :items="getTicketDefaultObjections"
            style="font-size: 15px"
            label="Objeción"
            class="pt-2"
          />
        </v-col>
        <v-col v-if="responseMessage" cols="12">
          <v-alert text type="error">
            {{ responseMessage }}
          </v-alert>
        </v-col>
        <v-col v-if="allowEdit" cols="12" class="text-center">
          <v-btn :loading="loading" small rounded color="primary" @click="onSave"> Guardar </v-btn>
          <v-btn small rounded @click="onCancel"> Cancelar </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TicketCardObjection",
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    editObjection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      objection: null,
      loading: false,
      responseMessage: null,
    };
  },
  computed: {
    ...mapGetters(["getAgent", "getTicket", "getTicketDefaultObjections", "getTicketStatesMap"]),
    allowEdit() {
      return this.getTicket && this.getTicket.objection !== this.objection;
    },
  },
  watch: {
    "getTicket.objection"(value) {
      if (!this.objection) this.objection = value;
    },
    allowEdit(value) {
      this.$emit("update:editObjection", value);
    },
  },
  created() {
    this.objection = this.getTicket.objection;
  },
  methods: {
    ...mapActions(["setTicketObjection"]),
    async onSave() {
      try {
        this.loading = true;
        this.responseMessage = null;

        if (!this.$refs.formObjection.validate())
          throw new Error("El formulario contiene datos inválidos, por favor verifique y vuelva a intentar");

        await this.setTicketObjection({
          ticket_id: this.getTicket.id,
          data: {
            objection: this.objection,
          },
        });
      } catch (error) {
        this.responseMessage = error.message || "Ocurrió un problema al actualizar objeción de la oportunidad";
      } finally {
        this.loading = false;
      }
    },
    async onCancel() {
      this.objection = this.getTicket.objection;
      this.responseMessage = null;
    },
  },
};
</script>
